module.exports = __webpack_public_path__ + "static/media/CamDslr2.8d383bfb.png";